export default {
  title: {
    id: 'product_page_refurb_process_card_title',
    defaultMessage: 'Quality guaranteed by the Back Market Promise.',
  },
  titleAdvantage1: {
    id: 'product_page_refurb_process_card_title_advantage1',
    defaultMessage: 'Fully',
  },
  contentAdvantage1: {
    id: 'product_page_refurb_process_card_content_advantage1',
    defaultMessage: 'cleaned and restored',
  },
  titleAdvantage2: {
    id: 'product_page_refurb_process_card_title_advantage2',
    defaultMessage: '100',
  },
  contentAdvantage2: {
    id: 'product_page_refurb_process_card_content_advantage2',
    defaultMessage: 'performance checks at most',
  },
  titleAdvantage3: {
    id: 'product_page_refurb_process_card_title_advantage3',
    defaultMessage: '30M+',
  },
  contentAdvantage3: {
    id: 'product_page_refurb_process_card_content_advantage3',
    defaultMessage: 'refurbished devices sold',
  },
  seeHowItWorks: {
    id: 'product_page_refurb_process_card_see_how_it_works',
    defaultMessage: 'See how it works',
  },
}
